import { form2fhir } from '../Date/Format/index.js'

import { transform } from './mapper.js'

const PRIMARY_PERFORMER = {
  coding: [
    {
      system: 'http://hl7.org/fhir/v3/ParticipationType',
      code: 'PPRF',
      display: 'primary performer'
    }
  ]
}

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Procedure'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'category', 'text' ],
    form: [ 'type' ]
  },
  {
    fhir: [ 'code', 'text' ],
    form: [ 'name' ]
  },
  {
    fhir: [ 'status' ],
    fhir_const: 'completed'
  },
  {
    fhir: [ 'performer', 0, 'actor', 'reference' ],
    form: [ 'physician', 'reference' ]
  },
  {
    fhir: [ 'performer', 0, 'actor', 'display' ],
    form: [ 'physician', 'display' ]
  },
  {
    fhir: [ 'performer', 0, 'role' ],
    fhir_const: PRIMARY_PERFORMER
  },
  {
    fhir: [ 'performer', 1, 'actor', 'display' ],
    form: [ 'facility' ]
  },
  {
    fhir: [ 'performedDateTime' ],
    form: [ 'date' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'notes', 0, 'text' ],
    form: [ 'comments' ]
  }
]

export const map = (data, patientId) => {
  const res = transform(data, mapping, [ 'form', 'fhir' ])
  const ptRef = { reference: `Patient/${patientId}` }
  res.subject = ptRef
  return res
}

export const unmap = data => {
  const form = transform(data, mapping, [ 'fhir', 'form' ])
  return form
}
